const dict = {
  custom: {
    email: {
      required: 'Bitte gib deine E-Mail-Adresse an.',
      email: 'Bitte gib eine gültige E-Mail-Adresse an.',
    },
    name: {
      required: 'Bitte gib deinen Vor- und Nachnamen an.',
    },
    gender: {
      required: 'Bitte wähle dein Geschlecht aus.',
    },
    age: {
      required: 'Bitte gib den Alter an.',
      numeric: 'Bitte gib den Alter in Zahlen an z.B. 14',
    },
    school: {
      required: 'Bitte wähle deine Schulform aus.',
    },
    year: {
      required: 'Bitte wähle deine Jahrgangsstufe aus.',
    },
  },
}

export default dict
